import axios from "axios";
import { USER_KEY } from "config/constants";
import { AUTH_TOKEN } from "config/constants";
import { API_BASE_URL } from "config/constants";
import { getAccessToken } from "utils";
import { handleError } from "utils";

export const loginUser = async ({ email, password }) => {
  try {
    let response = await axios.post(`${API_BASE_URL}/user/login`, {
      email,
      password,
    });
    const { status, result } = response.data;
    if (status === 200) {
      const access_token = result.data.access_token;
      const user = result.data.user;
      localStorage.setItem(AUTH_TOKEN, access_token);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
      return result;
    } else {
      return false;
    }
  } catch (error) {
    handleError(error);
  }
};
